
export const FLAMELINK_PATH = 'flamelink/environments/production/content/'
export const MEDIA_PATH = 'flamelink/media/files/'
export const PALEO_PATH = FLAMELINK_PATH + 'paleographyQuestion/en-US/'
export const PRIMER_PATH = FLAMELINK_PATH + 'primerPage/en-US/'
export const WORDS_PATH = FLAMELINK_PATH + 'word/en-US/'
export const LESSONS_PATH = FLAMELINK_PATH + 'lesson/en-US/'
export const LEVELS_PATH = FLAMELINK_PATH + 'level/en-US/'
export const MCQUESTION_PATH = FLAMELINK_PATH + 'multipleChoiceQuestion/en-US/'
export const FMQUESTION_PATH = FLAMELINK_PATH + 'fridgeMagnetQuiz/en-US/'
